import { sample } from 'effector';
import { $location } from 'models/location';
import { LocationGate } from 'models/router-gate';

sample({
    source: LocationGate.state,
    target: $location,
});
